import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch } from '~redux/hooks';

import TransferInventoryForm from '../TransferInventoryForm';

type TransferInventoryModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const TransferInventoryModal: FC<TransferInventoryModalProps> = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearTransferInventoryParams());
            dispatch(combinedActions.goldClearInventoryFilterParams());
            dispatch(combinedActions.goldGetAllInventoriesAttempt());
            dispatch(combinedActions.goldClearAllSerialNumbers());
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Transfer Inventory'
        >
            <TransferInventoryForm />
        </Modal>
    );
};

export default TransferInventoryModal;
